module.exports = __webpack_public_path__ + "img/b13b996.jpg";